<div class="new-template">
  <div class="premium-wrapper">
    <div class="premium">
      <div class="premium-header">Current Premium</div>
      <div class="premium-content">
        {{ premium | strToFloat | currency: 'USD' : 'symbol' : '1.2-2' }}
      </div>
    </div>
    @if (policy.cancelDate) {
      <div class="discounts-header">
        <div class="canceldate-label">Effective Dates</div>
        <div class="pilet">
          <div class="pilet-text">Updated</div>
        </div>
      </div>
    }
    @if (!policy.cancelDate) {
      <div class="canceldate-value">
        <div class="term">{{ policy.termDescription }}</div>
      </div>
    }
    @if (policy.cancelDate) {
      <div class="canceldate-value">
        {{ policy.periodStartDate | date: 'MM/dd/yyyy' }} -
        {{ policy.cancelDate | date: 'MM/dd/yyyy' }}
      </div>
    }
    @if (discountDescriptions?.length > 0) {
      <div class="discounts">
        <div class="discounts-header-save">Discounts & Savings</div>
        <ul>
          @for (discount of discountDescriptions; track discount) {
            <li class="pad-top-10 icon-complete discount">
              {{ discount }}
            </li>
          }
        </ul>
      </div>
    }
  </div>
</div>
